import useApi from 'assets/hooks/api/useApi';
import { combineStrings } from 'assets/utils/data/String';
import { keys } from 'lodash';
import claimStatusFlowApi from 'models/claims/claim/statusFlow/Api.Claim.StatusFlow';
import claimJobStatusFlowApi from 'models/claims/claimJob/statusFlow/Api.ClaimJob.StatusFlow';
import { useMemo } from 'react';

export default function useClaimStatuses() {
  const claimStatusInfoApi = useApi({ action: claimStatusFlowApi });
  const claimStatusInfo = claimStatusInfoApi.payload;
  const claimStatuses = useMemo(() => {
    return keys(claimStatusInfo).map((status) => {
      const [primary, secondary, reason] = status.split('_');
      const mainStatus = combineStrings(' - ', primary, secondary);
      return {
        id: status,
        subtitle: mainStatus,
        title: reason ?? mainStatus,
      };
    });
  }, [claimStatusInfo]);

  const claimJobStatusInfoApi = useApi({ action: claimJobStatusFlowApi });
  const claimJobStatusInfo = claimJobStatusInfoApi.payload;
  const claimJobStatuses = useMemo(() => {
    return keys(claimJobStatusInfo).map((status) => {
      const [primary, secondary, reason] = status.split('_');
      const mainStatus = combineStrings(' - ', primary, secondary);
      return {
        id: status,
        subtitle: mainStatus,
        title: reason ?? mainStatus,
      };
    });
  }, [claimJobStatusInfo]);

  return {
    claimStatuses,
    claimJobStatuses,
  };
}
